import styled from "styled-components";

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Code = styled.span`
  font-size: 0.82rem;
  font-weight: 500;
  color: #8fa3b0;
  flex-shrink: 0;
`;

const pill = `
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: 500;
  white-space: nowrap;
`;

export const DimensionTag = styled.span`
  ${pill}
  background: #1b6b78;
  color: #fff;
  border: 1px solid #1b6b78;
`;

export const SubDimensionTag = styled.span`
  ${pill}
  background: #fff;
  color: #1b6b78;
  border: 1px solid #7fc2cc;
`;

// Atenuado a proposito: el nivel es un dato de apoyo, no una categoria por la
// que el terapeuta navegue.
export const LevelTag = styled.span`
  ${pill}
  background: #fff;
  color: #a8b8c2;
  border: 1px solid #dfe6ec;
`;
